
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import { MONTHS } from '../../../resources/constants';
import { calculateMaxHeightContent } from '../../../resources/functions';
import { currencyFormat } from '../../../resources/helper';
import { getBranch } from '../../../store/user/selectors'
import ViewRegisterModal from '../../../components/Modal/ProfitLoss';
import moment from 'moment';
import { thirdPartyApi } from '../../../resources/hooks/api/thirdPartyApiHook';

interface Props {

}

const QBPLList: React.FC<Props> = () => {
    const urlParams = useParams();
    const { qbFetchPL } = thirdPartyApi();
    const { t } = useTranslation("scenes.thirdparty.quickbook.QBPLList");

    const [month, setMonth] = useState<any>(1);
    const [year, setYear] = useState<any>(2024);
    const [glProfitLossList, setGlProfitLossList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isShowViewRegister, setIsShowViewRegister] = useState<boolean>(false);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0)
    const [txnRegisterPayload, setTxnRegisterPayload] = useState<{
        startDate: string,
        endDate: string,
        account: number,
        hasEditAccess: boolean
    }>({
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        account: 0,
        hasEditAccess: false
    });

    const branchData = useSelector(getBranch)

    useEffect(() => {
        setContentMaxHeight(calculateMaxHeightContent(78));
    })

    const fetchProfitLossList = (year: number, month: number) => {
        const params: any = {
            "page": 1,
            "per_page": 5000,
            year: year,
            month: month,
            branch_id: +branchData['id']
        }

        setIsLoading(true);
        qbFetchPL(params, (message: string, resp: any) => {
            setIsLoading(false);
            if (resp && resp['data'] && resp['data']['data']) {
                setGlProfitLossList(resp.data.data);
            } else {
                setGlProfitLossList([]);
            }

        }, (message: string, resp: any) => {
            setGlProfitLossList([]);
            setIsLoading(false);
            toast.error(message);
        })
    }

    const getLastDayOfMonth = (month: any, year: any) => {
        return new Date(year, month, 0).getDate();
    }
    const percentageFormat = (value: any) => {
        return `${value}%`;
    };

    const calculateRatio = (amount: any, budget: any) => {
        // Ensure numerator and denominator are not zero to avoid division by zero error
        if (budget !== 0) {
            const ratio = (amount / budget) * 100;
            return percentageFormat(ratio.toFixed(2));
        } else {
            // Handle division by zero error gracefully
            return percentageFormat((0).toFixed(2))
        }
    };

    const _handleShowViewRegister = (data: any, startDate: string, hasEditAccess: boolean) => {
        setTxnRegisterPayload({
            startDate: startDate,
            endDate: `${year}-${month}-${getLastDayOfMonth(month, year)}`,
            account: data['account_chart']['id'],
            hasEditAccess: hasEditAccess
        })
        setIsShowViewRegister(true);
    }

    const _handleCloseViewRegister = () => {
        setIsShowViewRegister(false);
        fetchProfitLossList(year, month);
    }

    useEffect(() => {
        if (urlParams['month'] && urlParams['year']) {
            setMonth(urlParams['month']);
            setYear(urlParams['year']);
            fetchProfitLossList(+urlParams['year'], +urlParams['month']);
        }
    }, [urlParams])


    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-3 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h5 font-weight-700 mb-0 d-inline-flex">{t("title")}</h1>
                        </div>
                    </div>
                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                        <div className="loader"></div>
                    </div>
                </div>
                <div className="executive-dashboard">
                    <div className="table-responsive list-table table-scroll" style={{ maxHeight: contentMaxHeight }}>
                        <table className="table table-default table-bordered">
                            <thead>
                                <tr className="align-middle">
                                    <th className="text-center position-fix" colSpan={2}></th>
                                    <th className="text-center" colSpan={4}>{t("current.month")}<br />{month}/01/{year}  {t("to")}  {month}/{getLastDayOfMonth(month, year)}/{year}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    glProfitLossList.length && (
                                        <>
                                            {
                                                glProfitLossList.map((data: any, index: number) => {
                                                    const { report_code } = data['report_code'];
                                                    const shouldHideRow = ['VP', 'VP/IP', 'IP'].includes(report_code) && !data['total_amount'] /*&& !data['current_year_budget_amount'] && !data['ytd_total_amount'] && !data['budget_ytd_total_amount']*/ ? 'd-none' : '';
                                                    if (shouldHideRow == '') {
                                                        return (

                                                            <tr className={`position-fix align-middle h-60 bs-table-body-${data['report_code']}`} key={index}>

                                                                <td colSpan={2}><h4 className='sub-data'>{data['name']}</h4></td>
                                                                {
                                                                    ['GH', 'SH'].includes(data['report_code']) ? (data['account'] == 60000 ? (<td colSpan={3}></td>) : (
                                                                        <>
                                                                            {/* <td className="text-center"><h4 className='under-line'>RATIO</h4></td> */}
                                                                            <td className="text-center"><h4 className='under-line'>{t("amount")}</h4></td>
                                                                            {/* <td className="text-center"><h4 className='under-line'>BUDGET</h4></td>
                                                                            <td className="text-center"><h4 className='under-line'>RATIO</h4></td> */}
                                                                        </>
                                                                    )) :
                                                                    (

                                                                        <>
                                                                            {/* <td className="text-end"><h4 className='sub-data'>{percentageFormat((data['ratio'] || 0).toFixed(2))}</h4></td> */}
                                                                            <td className="text-end">
                                                                                {
                                                                                    report_code == 'VP' && data['total_amount'] && (
                                                                                        <span className='' onClick={() => _handleShowViewRegister(data, `${year}-${month}-01`, true)}>
                                                                                            <h4 className='sub-data clickable_link'>
                                                                                                {
                                                                                                    (data['account'] >= 9902 && data['account'] <= 9964) ?
                                                                                                        (data['total_amount'] <= 0 ? currencyFormat((+data['total_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs(+data['total_amount'] || 0).toFixed(2))})`) :
                                                                                                        (+data['total_amount'] >= 0 ? currencyFormat((+data['total_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs(+data['total_amount'] || 0).toFixed(2))})`)
                                                                                                }
                                                                                            </h4>
                                                                                        </span>
                                                                                    ) || <h4 className='sub-data'>
                                                                                        {
                                                                                            (data['account'] >= 9902 && data['account'] <= 9964) ?
                                                                                                (+data['total_amount'] <= 0 ? currencyFormat((+data['total_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs(+data['total_amount'] || 0).toFixed(2))})`) :
                                                                                                (+data['total_amount'] >= 0 ? currencyFormat((+data['total_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs(+data['total_amount'] || 0).toFixed(2))})`)
                                                                                        }
                                                                                    </h4>
                                                                                }
                                                                            </td>
                                                                            {/* <td className="text-end"><h4 className='sub-data'>
                                                                                {
                                                                                    (data['account'] >= 9902 && data['account'] <= 9964) ?
                                                                                        (data['current_year_budget_amount'] <= 0 ? currencyFormat((data['current_year_budget_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs((data['current_year_budget_amount'] || 0).toFixed(2)))})`) :
                                                                                        (data['current_year_budget_amount'] >= 0 ? currencyFormat((data['current_year_budget_amount'] || 0).toFixed(2)) : `(${currencyFormat(Math.abs((data['current_year_budget_amount'] || 0).toFixed(2)))})`)
                                                                                }
                                                                            </h4></td>
                                                                            <td className="text-end"><h4 className='sub-data'>{calculateRatio(data['total_amount'] || 0, data['current_year_budget_amount'] || 0)}</h4></td> */}
                                                                        </>
                                                                    )
                                                                }
                                                            </tr>
                                                        );
                                                    }
                                                })
                                            }
                                        </>

                                    ) || (
                                        <tr className="align-middle h-60">
                                            <td colSpan={3} className='text-center'><span>{t("noData")}</span></td>
                                        </tr>

                                    )
                                }

                            </tbody>
                        </table>


                    </div>
                    {
                        isShowViewRegister ?
                            <ViewRegisterModal
                                show={isShowViewRegister}
                                onHide={() => _handleCloseViewRegister()}
                                startDate={txnRegisterPayload.startDate}
                                endDate={txnRegisterPayload.endDate}
                                account={txnRegisterPayload.account}
                                hasEditAccess={txnRegisterPayload.hasEditAccess}
                            /> : <></>
                    }
                </div>
            </div>
        </div>

    )
}

export default QBPLList;
